import { render, staticRenderFns } from "./AttachmentsModal.vue?vue&type=template&id=5c714c25&scoped=true"
import script from "./AttachmentsModal.vue?vue&type=script&lang=js"
export * from "./AttachmentsModal.vue?vue&type=script&lang=js"
import style0 from "./AttachmentsModal.vue?vue&type=style&index=0&id=5c714c25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c714c25",
  null
  
)

export default component.exports